import { Modal } from "antd";
import React, { Component } from "react";
import ChangePath from "../services/ServiceApi";

class ModalSuccess extends Component {
  constructor(props) {
    super(props);
  }
  handleCancel(n) {
    window.location = n;
  }

  render() {
    return (
      <Modal
        title={null}
        centered
        visible={true}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img src={ChangePath.absoluteUrl("/img/modal_approve.svg")} className="img-fluid" />
          <h3 className="font-mont-sb fs-18 c-blue mt-3">
            {this.props.status}
          </h3>
          <button
            onClick={() => this.handleCancel(this.props.path_location)}
            className="btn btn-secondary"
          >
            OK
          </button>
        </div> 
      </Modal>
    );
  }
}

export default ModalSuccess;
